<div class="c-loading">
  <img src="/assets/img/spin-black.svg" alt="loading" class="icon" />
</div>
